import { useEffect, useState } from "react";
//import { pollQuestions } from "../../../static/pollQuestions";
import GraphScreen from "./poll/GraphScreen";
import PollScreen from "./poll/PollScreen";
import { PollContainer } from "./poll/style";
import axios from "axios";
import endpoints from "../../../utility/endpoints";
const Poll = ({ show, closePoll }) => {
  const [currentOne, setCurrentOne] = useState(0);
  const [showGraph, setShowGraph] = useState(false);
 const [pollQuestions, setpollQuestions] = useState([]);
  const skillstat = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/poll/getQuiz`,
      method: "GET",
       headers: {
         Authorization: `${auth.accessToken}|${auth.email}`,
       },
    });
    if (data.code === 200) {
      // Filter soft skill data

      setpollQuestions(data.data);
    } else {
      console.log("No data found");
    }
  };
  const showNextPoll = () => {
    if (currentOne < pollQuestions.length - 1) {
      setShowGraph(false);
      setCurrentOne((prev) => prev + 1);
    }
  };

  useEffect(() => {
    setShowGraph(false);
    skillstat();
  }, [show]);

  return (
 show? 
   <PollContainer className={`${show ? "active" : ""} `}>
      <div className="absolute modal  min-h-[320px] h-auto w-11/12 sm:w-[460px] flex flex-col items-center  justify-center rounded-2xl px-6  border-t-4 border-[#00A889]">
        <>
          {showGraph ? (
            <GraphScreen closePoll={closePoll} currentPoll={currentOne} showNextPoll={showNextPoll} />
          ) : (
            <PollScreen setShowGraph={setShowGraph} currentOne={currentOne} closePoll={closePoll} />
          )}
        </>
      </div>
    </PollContainer>
:null
  );
};

export default Poll;
